import { baseUrl } from "../api";

export const newsletterUrl = `${baseUrl}newsletter/`;
